import React from 'react'
import Reset from '../Reset/Reset'

const SectionInfoColumn = (props) => {

    const modal = {
        title: props.title,
        subtitle: props.subtitle,
        image: props.full_image
    }

    return (
        <div className={props.columnstyle}>
            <div className="team-member">
                <a className="portfolio-link" data-toggle="modal" target="_self"
                    href="#portfolioModal" onClick={(e) => props.showModal(modal)} >
                    <img className="mx-auto rounded-circle" alt="" src={props.image} />
                </a>
                <h4>{props.title}</h4>
                <p className="text-muted">{props.subtitle}</p>
                <div className={props.align}>
                    {props.content.map((c, k) => (
                        <div key={k} className="text-muted" dangerouslySetInnerHTML={{ __html: c }}></div>
                    ))}
                </div>
            </div>
        </div >
    )
}

const SectionTitle = (props) => {
    return (
        <div className="row">
            <div className="col-lg-12 text-center">
                <h2 className="section-heading">{props.sectioninfo.title}</h2>
                <h3 className="section-subheading text-muted" style={{marginBottom: '20px'}}>{props.sectioninfo.subtitle}</h3>
            </div>
        </div>
    )
}

const SectionInfo = (props) => {

    return (
        <section className="bg-light page-section" id={props.sectioninfo.key}>
            <SectionTitle {...props}/>
            <div className="container">
                <div className="row">
                    {
                        props.sectioninfo.columns.map((c, k) => (
                            <SectionInfoColumn key={k} {...c} showModal={props.showModal} />
                        ))}
                </div>
            </div>
            <Reset></Reset>
        </section>
    )
}

export default SectionInfo;